import { render } from "./default.vue?vue&type=template&id=3dfe0e2e&ts=true"
import script from "./default.ts?vue&type=script&lang=ts&external"
export * from "./default.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__